import styled from '../../../styles/styled';
export const NoteContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 0 10px 0',
    cursor: 'default',
    width: '100%',
});
export const NoteTextArea = styled.textarea(props => ({
    flexGrow: 0,
    fontSize: props.theme.text.size.medium,
    padding: props.theme.space[3],
    fontFamily: props.theme.text.bodyFontFamily,
    backgroundColor: props.theme.colors.grey05,
    border: `2px solid ${props.theme.colors.grey05}`,
    borderRadius: props.theme.radii[1],
    resize: 'none',
    outline: 'none',
    overflowY: 'scroll',
}), ({ activeHeight, isFocused, ...props }) => ({
    border: isFocused ? `2px solid ${props.theme.colors.azure}` : undefined,
    backgroundColor: isFocused ? props.theme.colors.white : undefined,
    ...(activeHeight
        ? {
            height: `${activeHeight + 6}px`,
        }
        : { height: '100%' }),
}));
export const NoteFooter = styled.div(({ theme }) => ({
    display: 'flex',
    margin: `${theme.space[3]}px 0 0 0`,
    width: '100%',
    alignItems: 'center',
}));
export const CharCounter = styled.span(({ theme }) => ({
    fontSize: theme.text.size.small,
    fontFamily: theme.text.bodyFontFamily,
    fontWeight: 400,
    flexGrow: 1,
    textAlign: 'right',
    paddingRight: '12px',
}), ({ charCount, characterLimit, theme }) => {
    let countColor;
    if (charCount < characterLimit - 25) {
        countColor = theme.colors.grey30;
    }
    else {
        countColor = theme.colors.red50;
    }
    return {
        ...(charCount === characterLimit
            ? {
                fontWeight: 'bold',
            }
            : {}),
        color: countColor,
    };
});
//# sourceMappingURL=note.styles.js.map